import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useNavigate } from "react-router-dom";
import classes from './LearningTracking.module.css'
import MainMenu from "./MainMenu/MainMenu";
import { fetchCoursesData } from '../../../store/course-actions';
import * as PathRouter from '../../../models/PathRoute'
import { useParams } from "react-router-dom";
import LeftSidePopup from "../../UI/LeftSidePopup";
import BackArrowMenu from '../../UI/BackArrowMenu';
import { submissionsApi } from "../../../utils";
import { throwApiError } from "../../lms-shared/store/error-handling-actions";
import { fetchTopicsData } from "../../../store/topic-actions";
import { IdeEnum } from "../../../models/IdeEnum";
import { SourceTypeTextEnum } from "../../../models/SourceTypeEnum";
import { ActivityTypeEnumText } from "../../../models/ActivityTypeEnum";

const LearningTracking = () => {

    const [currentCourse, setCurrentCourse] = useState();
    const [allAssessments, setAllAssessments] = useState([]);
    const [topicsData, setTopicsData] = useState([])
    const [menuItem, setMenuItem] = useState();

    const texts = useSelector(state => state.translate.texts)
    const { courses } = useSelector(state => state.courses);
    const { filteredAssessmentsList } = useSelector(state => state.filteredAssessments)
    const { applicationId, homeUrl } = useSelector(state => state.application);
    const { studyGroup, topics } = useSelector(state => state.topics);
    const uiData = useSelector((state) => state.general.uiData);
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const { id, applictionName } = useParams();

    useEffect(() => {
        if (courses.length && uiData && (!topics || studyGroup?.id != id)) {
            dispatch(fetchTopicsData(id, applictionName, true, uiData))
        }
    }, [id, courses, uiData, dispatch])

    useEffect(() => {
        fetchTocTopicsData()
    }, [topics])

    async function fetchTocTopicsData() {
        if (topics) {
            // let newTopics = []
            // newTopics = [...topics]
            // setTopicsData(newTopics)
            let newTopics = []
            newTopics = [...topics]
            const contest = newTopics[2]
            newTopics[2] = newTopics[1];
            newTopics[1] = contest;
            setTopicsData(newTopics)

        }
        else {
            setTopicsData(topics)
        }
    }

    useEffect(() => {
        if (!filteredAssessmentsList)
            fetchAssessments()
    }, [])

    async function fetchAssessments() {
        const newallAssessments = [];
        const data = {
            studyGroupId: id,
            activityType: ActivityTypeEnumText.Final,
            sourceTypes: [SourceTypeTextEnum.IDE],
            allParticipants: true,
        }
        submissionsApi.submissionsFilterRangePost({ submissionsRangeFilter: data }, (error, resdata, response) => {
            if (error) {
                setAllAssessments([])
                dispatch(throwApiError({ userMessage: texts.submissionsFilterError, error: error, statusCode: response?.statusCode, message: "submissionsFilterRangePost " + error.message, level: 1, component: "LearningTrackingAssessments", line: 41 }))
            }
            else {
                resdata.map(d => {
                    if (d.submissionStatusId === "Resubmitted" || d.submissionStatusId === "Submitted") {
                        newallAssessments.push(d)
                    }
                    d.assessmentContentData = JSON.parse(d.assessmentContentData)
                })
                setAllAssessments(newallAssessments)
            }
        })
    }

    useEffect(() => {
        if (menuItem) {
            if (menuItem.assessmentContentData.IdeId !== IdeEnum.MakeCode)
                navigate(`../${menuItem.id}`)
            else
                window.location.href = `./${menuItem.id}`;
        }
    }, [menuItem])


    useEffect(() => {
        if (!courses?.length && applicationId) {
            dispatch(fetchCoursesData())
        }
        const currentCoursesIndex = courses.findIndex(x => (x.id) === id);
        setCurrentCourse(courses[currentCoursesIndex])
    }, [id, courses, applicationId])

    const goTo = () => {
        window.location.pathname.includes(PathRouter.LEARNING_TRACKING_MAIN) ? navigate(`${homeUrl}/${PathRouter.LEARNING_TRACKING}`) : navigate(`${homeUrl}/${PathRouter.LEARNING_TRACKING}/${id}/${PathRouter.LEARNING_TRACKING_MAIN}`)
    }

    return (
        <div className={classes.LearningTracking}>
            <LeftSidePopup position={'relative'}  >
                {currentCourse && <BackArrowMenu title={texts.LearningTracking} onClick={goTo} select={true} />}
                <MainMenu topicsData={topicsData}></MainMenu>
            </LeftSidePopup>
            <Outlet></Outlet>
        </div >
    )
}

export default LearningTracking;

